// language=GLSL
import { BackSide, FrontSide, RawShaderMaterial, Vector3, AdditiveBlending } from "three";

import VERTEX_SHADER from "./shader/shield.vert"
import FRAGMENT_SHADER from "./shader/shield.frag"


const shieldMaterial = new RawShaderMaterial({
    uniforms: {
        c: { value : 1 },
        p: { value : 1.4 },
        viewVector: { value : new Vector3(0, 0, -1) },
        glowColor: { value: new Vector3(0.6, 0.9, 1)}
    },
    vertexShader: VERTEX_SHADER,
    fragmentShader: FRAGMENT_SHADER,
    side: BackSide,
    transparent: false,
    blending: AdditiveBlending
});

export default shieldMaterial;
